import { UpdatedStamp } from "@/components/data";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

import { statsMessageFor } from "./stats-api";
import { ORDERS_CAPTION } from "./stats-format";

// Orders and revenue from the funnel stats API, shown beside the Worker's live
// visitor and sign-up figures. Every value is the service's (I-4).

/** Says how fresh the order figures are; the shell's freshness line covers the Worker's. */
export function OrdersStamp({ dataAsOf, caption = ORDERS_CAPTION }: { dataAsOf: string | null | undefined; caption?: string }) {
  return (
    <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted-foreground">
      <span>{caption}</span>
      <UpdatedStamp generatedAt={dataAsOf ?? null} />
    </p>
  );
}

export function OrdersUnavailable({ error, areaName }: { error: unknown; areaName: string }) {
  return (
    <Alert>
      <AlertTitle>Orders and revenue unavailable</AlertTitle>
      <AlertDescription>{statsMessageFor(error, areaName)}</AlertDescription>
    </Alert>
  );
}
